import { StyledResultBackground, BackgroundWrapper, FloatingElement } from './ResultBackground.styled';
import { theme } from '../../theme';

const ResultBackground = ({ result = 'Lost'}) => {
  const background = result === 'Won' ? theme.winGreen : theme.loseRed;
  const asset = result === 'Won' ? '/assets/smiley_win.svg' : '/assets/skull_lose.svg'
  return (
    <StyledResultBackground $background={background}>
      <BackgroundWrapper>
        <FloatingElement src={asset}/>
        <FloatingElement src={asset}/>
        <FloatingElement src={asset}/>
        <FloatingElement src={asset}/>
        <FloatingElement src={asset}/>
      </BackgroundWrapper>
    </StyledResultBackground>
  );
};
export default ResultBackground;
